<script setup lang="ts">
import { onMounted } from 'vue'

import RChip from '../RChip/RChip.vue'

const props = defineProps<{
  tag: {
    bg: string
    color: string
    faIcon?: string
    name: string
  }
}>()
const SCRIPT_ID = 'iconify'

onMounted(() => {
  if (document.getElementById(SCRIPT_ID)) {
    return
  }

  const scriptEl = document.createElement('script')
  scriptEl.id = SCRIPT_ID
  scriptEl.src =
    'https://code.iconify.design/iconify-icon/2.2.0/iconify-icon.min.js'

  document.body.appendChild(scriptEl)
})
</script>

<template>
  <RChip
    class="!text-surface-0 !bg-surface-950"
    :style="{
      color: `${props.tag.color} !important`,
      backgroundColor: `${props.tag.bg} !important`,
    }"
  >
    <iconify-icon :icon="`fa-solid:${props.tag.faIcon}`" />
    {{ props.tag.name }}
  </RChip>
</template>
